class Product {
  constructor(element) {
    this.element = element;
    this.image = this.element.querySelector(".product-image");
    this.video = this.element.querySelector(".collection-grid__video");
    this.imageWrapper = this.element.querySelector(
      ".collection-grid__image-wrapper"
    );
    this.titleLink = this.element.querySelector(".home-page-collection__item-title");
    this.price = this.element.querySelector(".product-price");
    this.compare = this.element.querySelector(".compare-price");
    this.variants = Array.from( this.element.querySelectorAll(".variant-radio") );
    this.variantWrappers = this.element.querySelectorAll(".variant-wrapper");
    this.productTitleLink = this.element.querySelector(".product-title");
    this.defaultImageSrc = this.image.src;
    this.defaultVariantName = "";
    this.defaultPrice = ""; // Added this line for price tracking

    this.soldBadge = this.element.querySelector(".sold-badge");
    this.newBadge = this.element.querySelector(".new-badge");
    this.limitedBadge = this.element.querySelector(".limited-badge");
    this.backBadge = this.element.querySelector(".back-badge");
    this.specialBadge = this.element.querySelector(".special-badge");
    this.bestChoise = this.element.querySelector(".product-best-choise-image")

    this.imageWrapper.addEventListener(
      "mouseover",
      this.handleImageWrapperMouseOver.bind(this)
    );
    this.imageWrapper.addEventListener(
      "mouseout",
      this.handleImageWrapperMouseOut.bind(this)
    );

    this.addEventListeners();

    if (this.video) {
      this.addVideoEventListeners();
    }

    // Check the initially selected variant on page load
    const selectedVariant = this.variants.find(
      (variant) => variant.checked
    ) || this.variants[0];
    if (selectedVariant) {
      this.updateVariant(selectedVariant);
    }
  }

  preloadImages(urls, callback) {
    let loadedImages = 0;
    const totalImages = urls.length;

    urls.forEach((url) => {
      const img = new Image();
      img.onload = () => {
        loadedImages++;
        if (loadedImages === totalImages) {
          callback();
        }
      };
      img.onerror = () => {
        console.error("Error loading image: " + url);
        loadedImages++;
        if (loadedImages === totalImages) {
          callback();
        }
      };
      img.src = url;
    });
  }

  handleImageWrapperMouseOver() {
    this.imageWrapper.classList.add("hovered");
  }

  handleImageWrapperMouseOut() {
    this.imageWrapper.classList.remove("hovered");
  }

  addEventListeners() {
    this.variantWrappers.forEach((wrapper, index) => {
      wrapper.addEventListener("mouseover", () =>
        this.previewVariant(this.variants[index])
      );
      wrapper.addEventListener("mouseout", () => this.resetImageToDefault());

      this.variants[index].addEventListener("change", () =>
        this.updateVariant(this.variants[index])
      );
    });
  }

  addVideoEventListeners() {
    this.imageWrapper.addEventListener("mouseover", () => this.playVideo());
    this.imageWrapper.addEventListener("mouseout", () => this.stopVideo());
  }

  playVideo() {
    this.image.classList.add("hidden-element");
    this.video.classList.remove("hidden-element");

    if (this.video.tagName === "VIDEO") {
      this.video.play();
    }
  }

  stopVideo() {
    this.image.classList.remove("hidden-element");
    this.video.classList.add("hidden-element");

    if (this.video.tagName === "VIDEO") {
      this.video.pause();
    }
  }

  previewVariant(variant) {
    this.image.src = variant.getAttribute('data-image');
    const variantWrapper = variant.closest(".variant-wrapper");
    variantWrapper.classList.add("hovered");

    this.variantWrappers.forEach((wrapper) => {
      if (wrapper !== variantWrapper) wrapper.classList.add("not-hovered");
    });

    const variantNameElement = this.element.querySelector(".item-variant-name");
    if (variantNameElement) {
      this.defaultVariantName = this.defaultVariantName || variantNameElement.textContent;
      variantNameElement.textContent = variant.getAttribute('variant-name') || '';
    }

    // Add these lines to update the price on hover
    const priceElement = this.element.querySelector(".product-title p");
    if (priceElement && variant.getAttribute('data-price')) {
      this.defaultPrice = this.defaultPrice || priceElement.textContent;
      priceElement.textContent = variant.getAttribute('data-price');
    }

    this.toggleBadges(variant);
  }

  resetImageToDefault() {
    this.image.src = this.defaultImageSrc;
    this.variantWrappers.forEach((wrapper) => {
      wrapper.classList.remove("hovered");
      wrapper.classList.remove("not-hovered");
    });

    const variantNameElement = this.element.querySelector(".item-variant-name");
    if (variantNameElement) {
      variantNameElement.textContent = this.defaultVariantName || '';
    }

    // Add these lines to reset the price
    const priceElement = this.element.querySelector(".product-title p");
    if (priceElement && this.defaultPrice) {
      priceElement.textContent = this.defaultPrice;
    }

    // Reset the badges when resetting the image
    const selectedVariant = Array.from(this.variants).find(
      (variant) => variant.checked
    );
    this.toggleBadges(selectedVariant);
  }

  updateVariant(variant) {
    this.defaultImageSrc = variant.getAttribute('data-image');
    this.image.src = variant.getAttribute('data-image');

    const variantNameElement = this.element.querySelector(".item-variant-name");
    if (variantNameElement) {
      variantNameElement.textContent = variant.getAttribute('variant-name') || '';
      this.defaultVariantName = variant.getAttribute('variant-name') || ''; // Update the original name
    }

    // Add these lines to update the price on selection
    const priceElement = this.element.querySelector(".product-title p");
    if (priceElement && variant.getAttribute('data-price')) {
      priceElement.textContent = variant.getAttribute('data-price');
      this.defaultPrice = variant.getAttribute('data-price'); // Update the default price
    }

    const variantUrl = variant.getAttribute('data-url');

    if (variantUrl) {
      const productTitleLinks = this.element.querySelectorAll(".product-title");
      productTitleLinks.forEach((link) => {
        link.href = variantUrl;
      });

      const shopNowButton = this.element.querySelector(
        ".home-page-collection__button"
      );
      if (shopNowButton) {
        shopNowButton.href = variantUrl;
      }

      if (this.imageWrapper.tagName === "A") {
        this.imageWrapper.href = variantUrl;
        this.titleLink.href = variantUrl;
      }

      const productItemLink = this.element.closest(
        ".home-page-collection__item.product-item"
      );
      if (productItemLink && productItemLink.tagName === "A") {
        productItemLink.href = variantUrl;
      }
    }

    if (this.video && variant.getAttribute('data-video')) {
      let sources = this.video.getElementsByTagName("source");
      if (sources.length > 0) {
        for (let i = 0; i < sources.length; i++) {
          sources[i].src = variant.getAttribute('data-video');
        }
        this.video.load();
      } else {
        this.video.src = variant.getAttribute('data-video');
      }
    }

    this.toggleBadges(variant);
  }

  toggleBadges(variant) {
    if (this.soldBadge) {
      if (variant && variant.hasAttribute('sold-out')) {
        this.soldBadge.style.display = "block";
      } else {
        this.soldBadge.style.display = "none";
      }
    }

    if (this.limitedBadge) {
      if (variant && variant.hasAttribute('limited')) {
        this.limitedBadge.style.display = "block";
      } else {
        this.limitedBadge.style.display = "none";
      }
    }

    if (this.backBadge) {
      if (variant && variant.hasAttribute('back')) {
        this.backBadge.style.display = "block";
      } else {
        this.backBadge.style.display = "none";
      }
    }

        if (this.specialBadge) {
      if (variant && variant.hasAttribute('special')) {
        this.specialBadge.style.display = "block";
      } else {
        this.specialBadge.style.display = "none";
      }
    }

    if (this.bestChoise) {
      if (variant && variant.hasAttribute('best-choise')) {
        this.bestChoise.style.display = "block";
      } else {
        this.bestChoise.style.display = "none";
      }
    }

    if (this.newBadge) {
      if (variant && variant.hasAttribute('new')) {
        this.newBadge.style.display = "block";
      } else {
        this.newBadge.style.display = "none";
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll(".product-item");
  products.forEach((product) => new Product(product));
});